import { forwardRef } from '@chakra-ui/system';

import Text, { type TextProps } from '../../../../Text';
import { useCheckbox } from '../../hooks/useCheckbox';

const Label = forwardRef<TextProps, 'p'>((props, ref) => {
  const { state } = useCheckbox();
  const { isDisabled } = state;

  return (
    <Text ref={ref} {...props} {...(isDisabled && { variant: 'disabled' })} />
  );
});

export default Label;
